import React from "react";
import PropTypes from "prop-types";
import CustomModal from "../CustomModal";
import CustomButton from "../CustomButton";
import { NDPA_CONSENT_POINTS } from "../../utils/growNetwork";

const NdpaConsentModal = ({ isOpen, onClose, onConsent, loading }) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title="Contact Import Consent"
      maxWidth="520px"
    >
      <div className="gn-consent">
        <p className="gn-consent-lead">
          Before you import contacts, confirm you have permission to share their
          information with Workbrook so you can invite them to the platform.
        </p>
        <ul className="gn-consent-list">
          {NDPA_CONSENT_POINTS.map((point) => (
            <li key={point.title}>
              <strong>{point.title}.</strong> {point.text}
            </li>
          ))}
        </ul>
        <p className="gn-consent-legal">
          This complies with the Nigeria Data Protection Act (NDPA) 2023.
        </p>
      </div>
      <div className="d-flex justify-content-end">
        <CustomButton
          text="Cancel"
          backgroundColor="#fff"
          color="#64748B"
          borderColor="#CBD5E1"
          handleClick={onClose}
          additionalClass="mr-2"
        />
        <CustomButton
          text={loading ? "Saving..." : "I Consent — Continue"}
          backgroundColor="#3A6ED4"
          color="#fff"
          handleClick={onConsent}
          disabled={loading}
        />
      </div>
    </CustomModal>
  );
};

NdpaConsentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConsent: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default NdpaConsentModal;
